import { Button, Typography } from "@hellocarbo/lasagne";
import { Plus } from "lucide-react";
import { useTranslation } from "react-i18next";

import Card from "@/components/ui/Card";
import { TTrajectoryAction } from "@/types";

import ActionListItem from "./ActionListItem";

type AvailableActionsListProps = {
  availableActions: Array<TTrajectoryAction>;
};

function AvailableActionsList({ availableActions }: AvailableActionsListProps) {
  const { t, i18n } = useTranslation(["trajectory"]);

  return (
    <Card>
      <div className="mb-sm flex items-center justify-between">
        <Typography as="h2" step="2" weight="bold">
          {t("trajectory:actionPlan.availableActions")}
        </Typography>
        <Button
          as="a"
          shouldOpenNewTab
          shape="link"
          intent="secondary"
          PrefixIcon={Plus}
          href="https://forms.gle/vJHJsDbrm7z7YBFf9"
          size="small"
        >
          {t("trajectory:actionPlan.proposeAnAction")}
        </Button>
      </div>
      {availableActions.length ? (
        <ul className="gap-y-xs flex flex-col">
          {availableActions.map((availableAction) => {
            const title =
              i18n.language === "en"
                ? availableAction.title_en
                : availableAction.title_fr;
            const content =
              i18n.language === "en"
                ? availableAction.content_en
                : availableAction.content_fr;

            return (
              <ActionListItem
                {...availableAction}
                key={availableAction.id}
                title={title}
                content={content}
                isReadOnly={false}
                actionId={availableAction.id}
              />
            );
          })}
        </ul>
      ) : (
        <div className="border-grayscale-xx-light p-sm rounded-lg border text-center">
          <Typography step="-1" className="text-grayscale">
            {t("trajectory:actionPlan.noAvailableActions")}
          </Typography>
        </div>
      )}
    </Card>
  );
}

export default AvailableActionsList;
